<template>
    <router-view />
</template>
<script>
export default {
    name: "Diary"
}
</script>